import { useAccount } from 'modules/account/hooks/useAccount';

import { useNotifications } from './useNotifications';

export const useCommonNotificationsData = () => {
  const { group } = useAccount();

  const { notificationsAmount: unseenNotificationsAmount } = useNotifications({
    skipFetching: true,
    only_unseen: true,
    group,
  });

  return {
    unseenNotificationsAmount,
  };
};
